import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasSecurity = createSelector(selectJsonQuery, jsonQuery => getTermValue('security')(jsonQuery));
